import api from "./api";

export const DASHBOARD_BLOCKED_MESSAGE =
  "Dashboard access is disabled. Please contact support to renew your dashboard subscription.";

export const fetchDashboardAccess = async (username) => {
  const response = await api.get("/client-monitoring/dashboard-access", {
    params: { username },
    timeout: 10000,
  });
  return response.data;
};

export const isDashboardAccessBlocked = (access) =>
  access && access.effective_access === false;

export const getUsernameForAccessCheck = () => {
  try {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsed = JSON.parse(storedUser);
      if (parsed?.username) {
        return parsed.username;
      }
    }
  } catch (error) {
    console.error("Failed to parse stored user for access check", error);
  }
  return localStorage.getItem("username") || null;
};
